(function () {
  if (window.__variantUIInit) return;
  window.__variantUIInit = true;

  var observer = null;

  // ---------------------------------------------------------------------------
  // Slide / scroll mode
  // ---------------------------------------------------------------------------
  function initVariantScroll(root) {
    (root || document).querySelectorAll('.variant-mode--slide .variant-scroll').forEach(function (wrapper) {
      var viewport = wrapper.querySelector('.color-line-viewport');
      var container = wrapper.querySelector('.color-line');
      var prev = wrapper.querySelector('.prev');
      var next = wrapper.querySelector('.next');

      if (!viewport || !container || !prev || !next) return;

      var items = container.querySelectorAll('.variant-input');
      if (!items.length) return;

      var mobile = parseInt(wrapper.dataset.visibleMobile) || 4;
      var isMobile = window.innerWidth <= 768;
      var itemWidth = items[0].offsetWidth;
      var style = window.getComputedStyle(container);
      var gap = parseFloat(style.columnGap || style.gap || 0);

      var visible = isMobile
        ? mobile
        : Math.max(1, Math.floor((viewport.clientWidth + gap) / (itemWidth + gap)));

      var step = (itemWidth + gap) * visible;
      var maxScroll = container.scrollWidth - viewport.clientWidth;

      if (maxScroll > 1) {
        wrapper.classList.add('is-scroll');
      } else {
        wrapper.classList.remove('is-scroll');
        viewport.scrollLeft = 0;
      }

      function update() {
        var currentMaxScroll = container.scrollWidth - viewport.clientWidth;
        prev.disabled = viewport.scrollLeft <= 0;
        next.disabled = viewport.scrollLeft >= currentMaxScroll - 1;
      }

      prev.onclick = function () {
        viewport.scrollTo({ left: Math.max(viewport.scrollLeft - step, 0), behavior: 'smooth' });
      };

      next.onclick = function () {
        var currentMaxScroll = container.scrollWidth - viewport.clientWidth;
        viewport.scrollTo({ left: Math.min(viewport.scrollLeft + step, currentMaxScroll), behavior: 'smooth' });
      };

      if (!wrapper._slideScrollBound) {
        viewport.addEventListener('scroll', update);
        wrapper._slideScrollBound = true;
      }

      update();
    });
  }

  // ---------------------------------------------------------------------------
  // Size group sorting / reveal
  // ---------------------------------------------------------------------------
  function initSizeGroup(root) {
    var containers = (root || document).querySelectorAll('[data-size-group]');
    if (!containers.length) return;

    var getSizeValue = function (str) {
      if (!str) return 999;
      var match = str.match(/\d+/);
      return match ? parseInt(match[0]) : 999;
    };

    containers.forEach(function (container) {
      // Already processed — skip (also avoids re-clearing innerHTML on re-init)
      if (container.classList.contains('is-ready')) return;

      var groupType = container.dataset.groupType;
      var items = Array.from(container.querySelectorAll('.size-btn'));

      if (groupType === 'size') {
        var sorted = items.sort(function (a, b) {
          return getSizeValue(a.dataset.size) - getSizeValue(b.dataset.size);
        });

        container.innerHTML = '';
        sorted.forEach(function (el) { container.appendChild(el); });
      }

      container.classList.add('is-ready');
    });
  }

  // ---------------------------------------------------------------------------
  // Expand mode ("Show more")
  // ---------------------------------------------------------------------------
  function initVariantExpand(root) {
    (root || document).querySelectorAll('.variant-mode--expand .variant-scroll').forEach(function (wrapper) {
      var btn = wrapper.querySelector('.variant-toggle');
      var container = wrapper.querySelector('.color-line');

      if (!btn || !container) return;

      var mobile = parseInt(wrapper.dataset.visibleMobile) || 4;

      function update() {
        var items = Array.from(container.querySelectorAll('.variant-input'));

        if (!items.length) {
          wrapper.classList.add('is-empty');
          btn.style.display = 'none';
          return;
        }

        wrapper.classList.remove('is-empty');
        wrapper.classList.add('is-measuring');

        var visible = mobile;

        if (window.innerWidth > 768) {
          var firstTop = items[0].offsetTop;
          visible = items.filter(function (item) { return item.offsetTop === firstTop; }).length;
          visible = Math.max(1, visible);
        }

        wrapper.classList.remove('is-measuring');

        items.forEach(function (item, index) {
          item.classList.toggle('is-visible', index < visible);
        });

        wrapper.dataset.visible = visible;
        btn.style.display = items.length > visible ? '' : 'none';
      }

      btn.onclick = function () {
        wrapper.classList.toggle('is-expanded');
        btn.querySelector('span').textContent = wrapper.classList.contains('is-expanded')
          ? 'Show less'
          : 'Show more';
      };

      update();

      // Bind resize once per wrapper to avoid stacking listeners on re-init
      if (!wrapper._expandResizeBound) {
        window.addEventListener('resize', update);
        wrapper._expandResizeBound = true;
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Colour label (reflects the checked swatch value)
  // ---------------------------------------------------------------------------
  function initCustomVariantColorLabel(root) {
    (root || document).querySelectorAll('.variant-wrapper').forEach(function (wrapper) {
      var colorLabel = wrapper.querySelector('[data-variant-color-label]');
      if (!colorLabel) return;

      var checkedInput = wrapper.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        colorLabel.textContent = checkedInput.value;
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Run everything. Disconnect the observer while we mutate the DOM so our own
  // changes (sorting, class toggles) don't re-trigger us into a loop.
  // ---------------------------------------------------------------------------
  function initAll(root) {
    if (observer) observer.disconnect();
    try {
      initVariantScroll(root);
      initSizeGroup(root);
      initVariantExpand(root);
      initCustomVariantColorLabel(root);
    } finally {
      startObserving();
    }
  }

  // Expose for manual re-init if ever needed
  window.VariantUI = {
    initVariantScroll: initVariantScroll,
    initSizeGroup: initSizeGroup,
    initVariantExpand: initVariantExpand,
    initCustomVariantColorLabel: initCustomVariantColorLabel,
    initAll: initAll
  };

  // ---------------------------------------------------------------------------
  // Document-level listeners — bound ONCE
  // ---------------------------------------------------------------------------
  document.addEventListener('change', function (event) {
    var input = event.target.closest('input[type="radio"]');
    if (!input) return;
    var wrapper = input.closest('.variant-wrapper');
    if (!wrapper) return;
    var colorLabel = wrapper.querySelector('[data-variant-color-label]');
    if (!colorLabel) return;
    colorLabel.textContent = input.value;
  });

  document.addEventListener('click', function (event) {
    var label = event.target.closest('label');
    if (!label) return;
    requestAnimationFrame(function () { initCustomVariantColorLabel(); });
  });

  window.addEventListener('resize', function () { initVariantScroll(); });

  // ---------------------------------------------------------------------------
  // Re-init when variant markup is injected (Quick Shop modal). innerHTML-
  // injected <script> never runs, so we watch the DOM instead of relying on it.
  // ---------------------------------------------------------------------------
  var debounceTimer = null;
  function scheduleInit() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      // rAF so the freshly opened modal has been laid out before we measure
      requestAnimationFrame(function () { initAll(); });
    }, 50);
  }

  function isRelevant(node) {
    if (node.nodeType !== 1) return false;
    var sel = '.variant-wrapper, .variant-scroll, [data-size-group]';
    return (node.matches && node.matches(sel)) || (node.querySelector && node.querySelector(sel));
  }

  function startObserving() {
    if (!observer || !document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (window.MutationObserver) {
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (isRelevant(added[j])) { scheduleInit(); return; }
        }
      }
    });
  }

  // Extra hooks for the Quick Shop modal (harmless if they never fire)
  document.addEventListener('quickview:loaded', scheduleInit);
  document.addEventListener('quickview:open', scheduleInit);

  // ---------------------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------------------
  function boot() {
    requestAnimationFrame(function () { initAll(); });
    startObserving();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', function () { initAll(); });
})();
